const actionTypes = {
    GET_DEFAULT_RULES_SUCCESS: 'GET_DEFAULT_RULES_SUCCESS',
    GET_APPLICATION_RULE_SUCCESS: 'GET_APPLICATION_RULE_SUCCESS',
    GET_MATCHING_MAPPING_SUCCESS: 'GET_MATCHING_MAPPING_SUCCESS',
};

export default actionTypes;